import React from 'react'

const Manual_beneficio_descuento_categoria = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear beneficio de descuento en una categoría específica
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_beneficio_de_descuento_en_una_categoria_especifica__Pt5rjjwPQeuarQMZki8R7A?as=scrollable"
          className="scribe-iframe-general-133"
          width="100%"
          height="800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_beneficio_descuento_categoria
